import { FirebaseApp, initializeApp } from 'firebase/app'
import { getMessaging, getToken, NotificationPayload, onMessage } from 'firebase/messaging'
import { updateFirebaseToken } from '@/api/push';
import { FIREBASE_CONFIG, VAPID_KEY } from './config'

import {
    PushNotification,
    NotificationCallback,
    NotificationEmitter,
} from './types';

import { EventBus } from '@/lib/EventBus';

const firebase = (window as any).firebase;
const messages = {
    defaultNotificationTitle: 'Новое уведомление', 
    userEnteredChatText: 'Пациент вошёл в чат',
    consultationStart: 'consultation_started',
}
let app: FirebaseApp;

const initFirebase = () =>  {
    if (firebase.apps.length) {
        return;
    }
    
    app = initializeApp(FIREBASE_CONFIG);
}

const initMessaging = () => {
    const messaging = getMessaging(app);

    return messaging;
}

const registerWorker = () => {
    navigator.serviceWorker.register('/firebase-messaging-sw.js');

    return navigator.serviceWorker;
}


const saveNotificationToken = async (token: string) => {
    window.localStorage.firebaseToken = token;
    updateFirebaseToken(token);
}

const checkNotificationsPermission = async () => {
    const permission = await Notification.requestPermission();

    if (permission !== 'granted') {
        throw new Error('Permission\'re not granted')
    }
}

const parseNotificationMessage = (payload: NotificationPayload | undefined): PushNotification => {
    return {
        message: payload?.title || messages.defaultNotificationTitle,
    }
}

export const createNotificationEmitter = (): NotificationEmitter => { 
    initFirebase();
    const messaging = initMessaging();
    
    getToken(messaging, { vapidKey: VAPID_KEY })
        .then(saveNotificationToken)
        .catch((err: unknown) => {
            console.error('An error occurred while retrieving token. ', err);
        });

    const worker = registerWorker();
    
    const subscribeToNotification = (notify: NotificationCallback) => {
        onMessage(messaging, async ({ notification }) => {
            try {
                await checkNotificationsPermission();

                await (await worker).ready;
                const message = parseNotificationMessage(notification);
                
                if (message?.message === messages.consultationStart) {
                    EventBus.$emit('consultation:start');
                    message.message = messages.userEnteredChatText;
                    notify(message);

                    return;
                }

                EventBus.$emit('notification:new');

                notify(message);
            } catch (error: unknown) {
                console.error('An error occurred', error);
            }
        });
    }

    return {
        subscribeToNotification,
    }
}